module.exports = (__parcel__import__("1VNSY")).then(() => parcelRequire('fyWP3'));